// Inter with optical sizes (Inter Display on large titles), Apple devices use SF Pro instead.
import "@fontsource-variable/inter/opsz.css";
import "@agencyos/ui-web/ui.css";
import "./app.css";
import "./shell.css";
import "./lib/i18n";
import "./lib/session";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("#root element missing");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
